var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("让渠道更易搜，让合作更放心")]),_c('div',[_vm._v("合作热线：133-3288-8870 / 132-8881-0072")])])
}]

export { render, staticRenderFns }